import React, {useState, useEffect} from 'react';
import { connect } from 'react-redux';
import Head from '../../components/head/Head'
import {  message  } from 'antd';


import NumberFormat from 'react-number-format'


import { useTranslation } from 'react-i18next'

import './tan.css'
import {getLiushuiEth} from "../../api";

const mapStateToProps=(state)=>{
    return{
        isLogin:state.isLogin,
        address:state.address,
        chain:state.chain
    }
}

const IndexEth = (props) => {
    const { t } = useTranslation()
    const [num,setNum] = useState(0)
    const [list,setList] = useState([])
    const [classesList,setClassesList]=useState([])
    const [page,setPage]=useState(1)


    const _getNewClassess = (e) =>{

         _getLiushuiCcer(e)
    }


    const _getLiushuiCcer = (c) =>{
        if(props.address.length === 0 || props.isLogin === false){
            return false
        }
        getLiushuiEth({classes:c,page:page}).then(res=>{
            if(res.code === 0 ){

                if(res.data.classesList != null){
                    setClassesList(res.data.classesList)
                }


                    setList(res.data.list || [])


            }else{
                message.error(res.msg)
            }
        },error =>{
            message.error(error)
        })

    }





    useEffect(() => {
            window.scrollTo(0, 0)
            _getLiushuiCcer(999)
    }, 
    // eslint-disable-next-line
    [props.isLogin,num]);

    return (
        <>
            <Head/>
            
            <div className=' w-full min-h-screen px-4 mt-20 '>


                {/* people */}
                <div className=' w-full mt-9 px-4 pt-7 pb-10 shadow-md shadow-gray-900   bg-gradient-to-r from-black  to-black-right  rounded-2xl flex flex-col text-white'>
                    <div className=' w-full  flex felx-row items-center '>
                    {/* <div className=' w-2 h-4 mr-2 rounded-3xl bg-text-act'></div> */}
                    <img onClick={()=>window.history.back()} alt='rr' className='mr-1  ' src={require('../../assets/bg/game/back.png')} style={{"width":"30px"}}></img>
                        <span className=' text-sm font-bold text-text-act'>BNB  {t("r.历史记录")}</span>
                    </div>
                    <div className=' h-px bg-slate-800 mt-2'></div>

                    <div className="w-full py-3 flex flex-row justify-items-start items-center flex-wrap  border-b border-border-b">
                        {
                            classesList.length>0?
                                classesList.map((item,index)=> {
                                    return (
                                        <span onClick={()=>_getNewClassess(item.Classes)} className=" inline-block px-2 py-1 rounded-xl bg-gray-800 text-xs text-defi-font2 mb-2 mr-2">{item.Name}</span>
                                    )
                                }):null
                        }

                    </div>

                    {
                        list.length>0?
                            list.map((item,index)=> {
                                return (
                                    <div className="w-full flex flex-col  border-b border-border-b pb-3 pt-4">
                                        <div className='w-full flex flex-row items-center justify-between'>
                                            <span className=" text-xs">{t("r.类型")}：{item.classname}</span>
                                            {
                                                item.value>0?(
                                                    <div className=" text-green-400">
                                                        <span className=" text-sm mr-1">+</span>
                                                        <span className=" text-sm mr-1">
                                                    <NumberFormat
                                                        thousandsGroupStyle="thousand"
                                                        value={item.value}
                                                        prefix=""
                                                        decimalSeparator="."
                                                        displayType="text"
                                                        type="text"
                                                        thousandSeparator={true}
                                                        allowNegative={false}
                                                        decimalScale={6} />
                                                </span>
                                                        {/* <span className=" text-base">BNB</span> */}
                                                    </div>
                                                ):(
                                                    <div className=" text-red-500">
                                                        <span className=" text-sm mr-1">-</span>
                                                        <span className=" text-sm mr-1">
                                                    <NumberFormat
                                                        thousandsGroupStyle="thousand"
                                                        value={item.value}
                                                        prefix=""
                                                        fixedDecimalScale
                                                        decimalSeparator="."
                                                        displayType="text"
                                                        type="text"
                                                        thousandSeparator={true}
                                                        allowNegative={false}
                                                        decimalScale={4} />
                                                </span>
                                                        {/* <span className=" text-base">MEBA</span> */}
                                                    </div>
                                                )
                                            }


                                        </div>
                                        <div className='w-full mt-2 flex flex-row items-center justify-between text-gray-400'>
                                            <span className=" text-xs">{t("r.备注")}：{item.memo}</span>
                                            <span className=" text-xs mr-1">{item.add_time}</span>
                                        </div>
                                    </div>
                                )
                            }):(
                                <div  className=' w-full  py-32 flex flex-row items-center justify-center text-gray-400 text-xs'>
                                    No data
                                </div>
                            )
                    }




                </div>



            </div>
            <div className=' w-full h-8'></div>
           


        </>
    );
}

export default connect(mapStateToProps)(IndexEth);
